export default function storePortfolioFormData(value) {

    return dispatch => dispatch({
        type: 'SAVE_PORTFOLIOFORMDATA_FULFILLED',
        payload: value
    });
}


// WEBPACK FOOTER //
// ./src/actions/VXC/storePortfolioFormData.js